import '../App.css';
import { Button, Navbar, Nav } from 'react-bootstrap';
import 'sf-font';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegram,faDiscord } from '@fortawesome/free-brands-svg-icons';
import React, { Component } from 'react';

class App extends Component {
 
  
  render() {
   
    const currentYear = new Date().getFullYear();

return (

  <header className="App-header">
    <div className='container' style={{ background: "#000000" }}>
      
     
    <div className="nftminter" style={{ border: "0", borderRadius: "5px", background: "transparent", marginTop: "10px", marginBottom: "10px", }}>
             
             <Navbar collapseOnSelect expand="md"  variant="dark" style={{ color: 'transparent', background: "transparent", marginRight: "3px",marginLeft: "3px", border: "0", }}>
             
             
             <div className="social-icons">
             <a href="https://twitter.com/JustPoly">
   <FontAwesomeIcon icon={faTwitter} type= "button"size="lg" className="social-icon" />
   </a>
   <a href="">
   <FontAwesomeIcon icon={faTelegram} size="lg" className="social-icon" />
   </a>
   <a href="">
   <FontAwesomeIcon icon={faDiscord} size="lg" className="social-icon" />
   </a>
   
   <style>
     {`
       .social-icons {
         display: flex;
         justify-content: center;
       
         color: #ccc;
         margin-right: auto;
       }

       .social-icon {
         margin-right: 10px;
         margin-left: 10px;
       }

       a {
         color: #ccc;
       }
       a:hover {
         color:#aaa;
        
       }


       @media (max-width: 768px) {
         .social-icons {
           display: flex;
           justify-content: left;
          
           color: #ccc;
           
        
         }
       }
     `}
   </style>
 </div>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{color:"transparent", background: "transparent", marginTop: "auto", border: "0", }}/>
       
        <Navbar.Collapse id="responsive-navbar-nav"  style={{textAlign: "left", background: "transparent", marginTop: "auto", border: "0", }}>
        
         <Nav className="mr-auto ml-auto ml-lg-0" >
         <Button variant="default" href="/" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }}>HOME</Button>
         <Button variant="default" href="/about" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }}>ABOUT</Button>
         <Button variant="default" href="/tokenInfo" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >TOKEN INFO</Button>
         <Button variant="default" href="/roadmap" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >ROADMAP</Button>
         <Button variant="default" href="" style={{ color: "#ccc", backgroundColor: "#ffffff10", margin: "5px", marginTop: "5px" }} >STAKED</Button>    
       </Nav></Navbar.Collapse></Navbar></div>

         


 
<div className='nftminter' style={{ background: "transparent", marginTop: "auto", border: "0", }}>
               
<label id='text' style={{ textAlign: "left", margin: "auto", color: "#ccc",marginTop: "auto", fontWeight: "bold", fontSize: "15px" }}>
              
<ul>
<li> Name : JustPoly</li>
<li> Symbol : (JP)</li>
<li>Supply : 850,000,000</li>
<li> Chain : Polygon</li>
<li> Contract Address : <a href="https://polygonscan.com/token/0xe70c72e69be09b9b4fe28bca443371d424851b9a" > CLICK HERE</a></li>
</ul>


<ul><li>Airdrops (29.41%) 250,000,000 The airdrop allocation is dedicated to distributing tokens to a wide range of users, potential investors and community members.
It aims to create awareness, foster engagement, and incentivize adoption of the JustPoly ecosystem.
The airdrop can be executed through various channels, such as social media campaigns, referral programs, or partnerships.
By providing tokens to a larger audience, we aim to create a strong user base and generate interest in JustPoly.
</li></ul>

<ul><li>Marketing (5.88%) 50,000,000 The marketing allocation is designed to support marketing activities and strategies that promote the JustPoly project.
These tokens will be used for initiatives such as influencer collaborations, content creation, community engagement, targeted advertising and other marketing campaigns.
The goal is to build brand awareness, attract potential investors and users, and showcase the unique value proposition of JustPoly. 
</li></ul>


<ul><li>Burning Target (17.65%) 150,000,000 The burning plan allocation is dedicated to reducing the token supply over time.
This mechanism involves systematically burning tokens once specific milestones or targets are reached.
Token burning helps increase the scarcity and value of the remaining tokens in circulation.
The milestones or conditions for token burning can be predefined, such as achieving a certain market cap, user base, or timeframe. 
By implementing a burning plan, we aim to create a deflationary aspect to the tokenomics and potentially enhance the value of JustPoly tokens.
</li></ul>
    

  
      
      <style>
        {`
      

       c {
           max-width: 800px;
            margin: 10px;
          }

        h1, h2, p, li {
          text-align: left;
          margin: 10px;
        
          max-width: auto;
          font-weight:bold;
          color:#ccc;
        }
        h2 {
         
          margin-top: 10px;
        
        }
        ul {
          padding-left: 20px;
          margin: auto;
          
          
        }

        @media (max-width: 768px) {
          c {
            font-size: 12px;
            margin: auto;
            text-align: left;
            
          }
        }
      `}</style>
                  </label>
              </div>

              
        




      
      <div className='footer' style={{ background: "transparent", border: "0" }}>
        <div className='col'>
         
          <b>&copy; {currentYear} JUST POLY DAPP</b>
          <style>{`
  
        b {
          text-align: center;
          font-size: 14px;
          font-weight: arial;
        }

      
      `}</style>
        </div>
      </div>
    </div>
  </header>
);
}
}

export default App;